export default __webpack_public_path__ + "static/media/hero-home.c71660e9.png";